<template>
  <div class="novice-module">
    <div class="k-novice" :style="aStyle">
      <div
        class="receive-btn"
        :style="btnStyle"
        :class="{
          gray: btnStatus().style.gray,
          center: this.draw.btnLeft == -1
        }"
        @click="startTurns"
      ></div>
    </div>
  </div>
</template>

<script>
const muduleBgHeight = 935;
const btnHeight = 93;
const btnWidth = 294;
import { mapGetters } from 'vuex';
export default {
  name: 'McNovice',
  props: {
    draw: {
      type: Object,
      default: () => {}
    },
    view: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },

  data() {
    return {
      height: muduleBgHeight,
      btnHeight: btnHeight,
      btnWidth: btnWidth,
      defaultModuleBg:
        '//cdn-tx-admin-test.3kwan.com/2023/07/24/0f969bf80a7ca0d748253debe6bf5fc6.jpg',
      defaultBtnBg:
        '//cdn-tx-admin-test.3kwan.com/2023/07/24/43d83a17e9e9077695a5885e50006357.png',
      lock: false
    };
  },
  computed: {
    state() {
      return this.$store.state;
    },
    receivePrize() {
      return this.view?.ext_params?.receive_prize || '';
    },
    prizeList() {
      return this.list.reduce((prev, cur) => {
        prev.push({
          ...cur,
          receive_prize: this.receivePrize[cur.prize_id]
        });
        return prev;
      }, []);
    },
    ...mapGetters(['prize']),
    aStyle() {
      return {
        height: this.$unit(this.height),
        backgroundImage: `url(${this.draw.bg || this.defaultModuleBg})`
      };
    },
    btnStyle() {
      return {
        height: this.$unit(this.btnHeight),
        width: this.$unit(this.btnWidth),
        left: this.draw.btnLeft == -1 ? '50%' : this.$unit(this.draw.btnLeft),
        bottom: this.$unit(this.draw.btnBottom),
        backgroundImage: `url(${this.btnStatus().imgPath})`
      };
    }
  },
  watch: {
    draw() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.onerror = () => {
        this.height = muduleBgHeight;
      };
      img.src = this.draw.bg;
      let btn = new Image();
      btn.onload = () => {
        let h = btn.height;
        let w = btn.width;
        this.btnHeight = h;
        this.btnWidth = w;
      };
      btn.onerror = () => {
        this.btnHeight = btnHeight;
        this.btnWidth = btnWidth;
      };
      btn.src = this.draw.btn;
    },
    btnStatus() {
      var imgPath = this.defaultBtnBg;
      var style = { gray: false };
      if (this.viewStatus != 2 && this.draw.btn != '') {
        imgPath = this.draw.btn;
      } else {
        let curPrize = this.prizeList[0];
        let curPrizeStatus = curPrize.receive_prize;
        switch (curPrizeStatus) {
          case 1:
            //已领取
            imgPath = this.draw.finishBtn;
            break;
          case 2:
            imgPath = this.draw.btn;
            //可领取
            break;
          case 3:
            //不可领取
            imgPath = this.draw.btn;
            style.gray = true;
            break;
        }
      }
      return { imgPath, style };
    },
    // 开始抽奖
    startTurns() {
      if (this.viewStatus != 2) return;
      if (this.state.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
        return false;
      }
      // 如果还不可以转动
      if (!this.canBeRotated()) {
        return false;
      }
      // 先上锁
      this.lock = true;
      let curPrize = this.prizeList[0];
      let curPrizeStatus = curPrize.receive_prize;
      if (curPrizeStatus == 1) {
        //查看奖励
        this.$store.commit('UPDATE_MODULE_ID', this.moduleId);
        this.$store.commit('OPEN_DIALOG', 'PrizeRecord');
        this.lock = false;
        return false;
      }
      this.drawPrize();
    },
    //请求服务端抽奖
    async drawPrize() {
      let { code, data } = await this.$api.prize.receivePrize({
        module_id: this.moduleId,
        guid: this.state.userInfo.guid,
        server_id: this.state.userInfo.server_id,
        role_id: this.state.userInfo.role_id,
        prize_id: this.list[0].prize_id
      });
      if (code !== 0) {
        this.lock = false;
        return;
      }
      this.Track(5, this.moduleId);
      this.$store.commit('UPDATE_PRIZE', data);
      this.endTurns();
    },
    // 已经转动完转盘触发的函数
    endTurns() {
      // 中奖
      this.$store.commit('OPEN_DIALOG', 'Prize');
      // 解锁
      this.lock = false;
      this.$store.dispatch('INIT_ACTIVITY');
    },
    // 判断是否可以转动
    canBeRotated() {
      if (this.lock) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.k-novice {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 499;
  .receive-btn {
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .center {
    transform: translateX(-50%);
  }
  .gray {
    filter: grayscale(100%);
  }
}
</style>
